import React, { Fragment, useState } from "react";
import CommonFrom from "../../../Common/Components/Form";
import Form from "./Edit/ActiveItemReact/Components/Form";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import BoxShadow from "../../../Common/Components/BoxShadow";
import { ToTimeHM, removeSepMoney, sepJustMoney } from "../../../Common/Function";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Stack from "@mui/material/Stack";
import { Get } from "../../../../Request";
const Index = () => {

    const [form, setForm] = useState({ loading: false });

    const submitHandeler = () => {
        setForm({ ...form, loading: true });
        Get({ url: "/admin_edit_price", data: form, stat: true }).then(res => {
            setForm({ ...form, loading: false });
        })
    }


    return (
        <BoxShadow
            style={{
                padding: "10px",
            }}
        >
            <div className="row my-4">
                <div className="col-4 mb-3">
                    <TextField fullWidth id="outlined-basic" label="کد پیگیری" variant="outlined"
                        onChange={e => setForm({ ...form, trackingcodeorder: e.target.value })} />
                </div>

                <div className="col-4 mb-3 whiteLabel">
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">روز</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={form?.dayname}
                            onChange={e => setForm({ ...form, dayname: e.target.value })}
                        >
                            <MenuItem value={"saturday"}>شنبه</MenuItem>
                            <MenuItem value={"sunday"}>یکشنبه</MenuItem>
                            <MenuItem value={"monday"}>دوشنبه</MenuItem>
                            <MenuItem value={"tuesday"}>سه شنبه </MenuItem>
                            <MenuItem value={"wednesday"}>چهار شنبه</MenuItem>
                            <MenuItem value={"thursday"}>پنج شنبه</MenuItem>
                            <MenuItem value={"friday"}>جمعه</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div className="col-4 ">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                            <TimePicker
                                ampm={false}
                                size="small"
                                openTo="hours"
                                views={["hours", "minutes"]}
                                minutesStep={5}
                                inputFormat="HH:mm"
                                mask="__:__"
                                label={"ساعت شروع"}
                                value={form?.start}
                                onChange={newValue => {
                                    setForm({
                                        ...form,
                                        "start": ToTimeHM(newValue),
                                    });
                                }}
                                renderInput={params => <TextField {...params} />}
                            />
                        </Stack>
                    </LocalizationProvider>
                </div>

                <div className="col-4 mb-3">
                    <TextField fullWidth id="outlined-basic" label="قیمت فروش" variant="outlined" value={sepJustMoney(form?.price)}
                        onChange={e => setForm({ ...form, price: removeSepMoney(e.target.value) })} />
                </div>

                <div className="col-4 mb-3">
                    <TextField fullWidth id="outlined-basic" label="قیمت خرید" variant="outlined" value={sepJustMoney(form?.buyprice)}
                        onChange={e => setForm({ ...form, buyprice: removeSepMoney(e.target.value) })} />
                </div>

                <div className="col-4 mb-3 whiteLabel">
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label"> نوع </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={form?.dayname}
                            onChange={e => setForm({ ...form, type: e.target.value })}
                        >
                            <MenuItem value={"eq"}>همین سانس</MenuItem>
                            <MenuItem value={"noteq"}>همه سانس ها به غیر از این سانس</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div className="col-12">
                    <button disabled={form.loading} className="btn btn-primary justify-content-center mt-2"
                        style={{ width: "150px" }}
                        onClick={e => submitHandeler()}>
                        {form.loading
                            ? "صبر کنید ..."
                            : "ثبت"
                        }
                    </button>
                </div>

            </div>

        </BoxShadow>
    );
};

export default Index;
